/**
 * wallet store
 */
import { defineStore } from 'pinia';
import { start, storeToRefs, useTenantStore, useUserStore } from '../../index';
import { walletServices } from '../services';
import { filter, map, max, toNumber } from 'lodash-es';
import { getp } from '@star/utils';

type StateData = {
  depositChannelList: any[];
  depositChannelData: any[];
  bindWalletAddressList: any[];
  withdrawItems: any[];
  withdrawConfig: Record<string, any>;
  exchangeRate: number;
  // [propName: string]: any;
};

/**
 * CHARGE_DESC_NEW: 人工充值说明
 * RECHARGE_NAVIGATION_CORNER_MARK: 底部充值导航角标
 * */
type OptionCodes = 'CHARGE_DESC_NEW' | 'RECHARGE_NAVIGATION_CORNER_MARK';

export const useWalletStore = defineStore({
  id: 'wallet',
  state: (): StateData => {
    return {
      depositChannelList: [], // 充值渠道列表（all）
      depositChannelData: [], // 充值渠道分组数据（all）
      bindWalletAddressList: [], // 绑定的钱包地址列表
      withdrawItems: [], // 提现渠道
      withdrawConfig: {}, // 提现配置数据
      exchangeRate: 1, // 虚拟货币地区汇率
    };
  },
  getters: {
    // 提现费率列表
    withdrawFeeList: (state): any[] => {
      return JSON.parse(state.withdrawConfig?.listFeel || '[]');
    },
    // 充值最大奖励百分比
    maxDepositBonusPercentage: state => {
      return max(
        map(state.depositChannelData, it => {
          return (
            max(
              map(
                filter(it.data, item => item.pay_org_id !== 205),
                item => toNumber(item.maxPercentage || 0)
              )
            ) ?? 0
          );
        })
      );
    },
  },
  actions: {
    async init() {},
    setWithdrawItems(data: any[]) {
      this.withdrawItems = data;
    },
    /**
     * 获取提现渠道icon
     */
    getIconSrc(cut?: number) {
      return '/images/withdraw/ico_cut_' + cut + '.png';
    },
    /**
     * 获取充值渠道列表 mark: 1线下 2线上 3快速
     */
    async getPayChannelList(payload: any = {}) {
      const { userInfo } = storeToRefs(useUserStore());
      const { tenantInfo } = storeToRefs(useTenantStore());
      try {
        // const res: any = await walletServices.getPayChannelList([toNumber(tenantInfo.value.tid), userInfo.value.cust_id]);
        const res: any = await walletServices.getPayChannelList({
          tid: tenantInfo.value.tid,
          cust_id: userInfo.value.cust_id,
        });
        console.log('getPayChannelList', res, tenantInfo.value.tid, userInfo.value.cust_id);
        this.depositChannelData = res?.data || [];
        return Promise.resolve(res?.data || []);
      } catch (error: any) {
        return Promise.reject([]);
      }
    },
    async isHasDkRecharge(payload: any = {}) {
      const { userInfo } = storeToRefs(useUserStore());
      const { tenantInfo } = storeToRefs(useTenantStore());
      try {
        const res: any = await walletServices.isHasDkRecharge({
          tid: tenantInfo.value.tid,
          cust_id: userInfo.value.cust_id,
        });
        console.log('isHasDkRecharge', res);
        return Promise.resolve(res?.data || []);
      } catch (error: any) {
        return Promise.reject([]);
      }
    },
    /**
     * 返回用户钱包地址
     * contact_name:姓名 id_card_log_addr:证件图片地址 id_card:证件号码 country:国家 document_type:证件类型
     * */
    async getBindWalletAddressList(payload = []) {
      const { userInfo } = storeToRefs(useUserStore());
      const { tenantInfo } = storeToRefs(useTenantStore());
      try {
        const res: any = await walletServices.getBindWalletAddressList([
          tenantInfo.value.tid,
          userInfo.value.cust_id,
          1,
          20,
          ...payload,
        ]);
        this.bindWalletAddressList = res?.data?.data || [];
        return Promise.resolve(res?.data?.data || []);
      } catch (e: any) {
        return Promise.resolve([]);
      }
    },
    /**
     * 用户的默认银行卡信息
     */
    async reqDefaultBankCard2() {
      const { userInfo } = storeToRefs(useUserStore());
      const { tenantInfo } = storeToRefs(useTenantStore());
      try {
        // const res: any = await walletServices.reqDefaultBankCard2([tenantInfo.value.tid, userInfo.value.cust_id]);
        const res: any = await walletServices.reqDefaultBankCard({
          tid: tenantInfo.value.tid,
          cust_id: userInfo.value.cust_id,
        });
        return Promise.resolve(res?.data || []);
      } catch (e: any) {
        return Promise.resolve([]);
      }
    },
    /**
     * 提现配置数据
     */
    async getWithdrawConfig() {
      const { userInfo } = storeToRefs(useUserStore());
      const { tenantInfo } = storeToRefs(useTenantStore());
      try {
        const res: any = await walletServices.getWithdrawConfig([tenantInfo.value.tid, userInfo.value.cust_id]);
        this.withdrawConfig = res?.data;
        return Promise.resolve(res?.data);
      } catch (e: any) {
        this.withdrawConfig = {};
        return Promise.resolve(undefined);
      }
    },
    /**
     * 获取虚拟货币地区汇率
     */
    async getExchangeRateData() {
      const { tenantInfo } = storeToRefs(useTenantStore());
      const data = {
        tid: tenantInfo.value.tid,
        option_code: 'EXCHANGE_RATE_OF_WITHDRAWAL_VIRTUAL_CURRENCY',
      };
      try {
        const res: any = await walletServices.getExchangeRateData(data);
        console.log(res, '6666666666666');
        this.exchangeRate = toNumber(res?.data?.value ?? 1);
        return Promise.resolve(this.exchangeRate);
      } catch (error) {
        return Promise.reject(this.exchangeRate);
      }
    },
    /**
     * 获取银行列表
     */
    async reqNewBankList() {
      const { tenantInfo } = storeToRefs(useTenantStore());
      try {
        const res: any = await walletServices.reqNewBankList([tenantInfo.value.tid]);
        return Promise.resolve(res.data || []);
      } catch (error) {
        return Promise.resolve([]);
      }
    },
    /**
     * 设定默认银行卡
     * @payload.pay_info_id @requires
     * @payload.key 本次请求的key，默认为default
     * @payload.options 更多参数 JSON
     */
    async reqReDefaultBankCard(payload: Record<string, any>) {
      const { userInfo } = storeToRefs(useUserStore());
      const { tenantInfo } = storeToRefs(useTenantStore());
      try {
        const res: any = await walletServices.reqReDefaultBankCard([
          tenantInfo.value.tid,
          payload.pay_info_id,
          userInfo.value.cust_id,
        ]);
        return Promise.resolve(res.data);
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    /**
     * 检查提现密码是否正确
     * */
    async reqTestWithdrawPassword(payload: any = {}) {
      const { userInfo } = storeToRefs(useUserStore());
      const { tenantInfo } = storeToRefs(useTenantStore());
      try {
        const res: any = await walletServices.reqTestWithdrawPassword({
          tid: tenantInfo.value.tid,
          ...payload,
          acct_pwd: getp(payload.acct_pwd.trim()),
          cust_code: userInfo.value.cust_code,
        });
        return Promise.resolve(res.data);
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    /**
     * 增加提款
     */
    async reqAddWithdraw(payload: any = {}) {
      const { userInfo } = storeToRefs(useUserStore());
      const { tenantInfo } = storeToRefs(useTenantStore());
      try {
        const data = {
          ...payload,
          acct_id: userInfo.value.acct_id,
          acct_pwd: payload.acct_pwd ? getp(payload.acct_pwd) : '',
          amount: payload.amount,
          chan_code: payload.chan_code || start.chanCode,
          cust_code: userInfo.value.cust_code,
          cust_id: userInfo.value.cust_id,
          oper_code: userInfo.value.cust_code,
          pay_info_id: payload.pay_info_id || '',
          pay_name: payload.pay_name ? payload.pay_name.replace(/&middot;/g, '·') : '',
          pay_no: payload.pay_no || '',
          pay_org_id: payload.pay_org_id || '',
          pay_org_name: payload.pay_org_name || '',
          open_addr: payload.open_addr || '',
          remark: '审核中',
          state: 1,
          tid: tenantInfo.value.tid,
          withdraw_type: 1,
        };
        const res: any = await walletServices.reqAddWithdraw(data);
        if (res && res.type === 'success') {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    /**
     * 一些配置 线下充值银行卡配置
     */
    async reqOfflineConfig() {
      const { tenantInfo } = storeToRefs(useTenantStore());
      try {
        let data = {
          tid: tenantInfo.value.tid,
          option_code: 'OFFLINE_RECHARGE_LIMIT',
        };
        const res: any = await walletServices.reqOfflineConfig(data);
        if (res?.data?.value) {
          res.data.value = JSON.parse(res.data.value);
        }
        if (res?.data?.value2) {
          res.data.value2 = JSON.parse(res.data.value2);
        }
        return Promise.resolve(res?.data);
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    /**
     * 获取系统配置
     */
    async getSysConfig(option_code: OptionCodes) {
      const { tenantInfo } = storeToRefs(useTenantStore());
      try {
        let data = {
          tid: tenantInfo.value.tid,
          option_code,
        };
        const res: any = await walletServices.getSysConfig(data);
        if (res?.data?.value) {
          res.data.value = JSON.parse(res.data.value);
        }
        if (res?.data?.value2) {
          res.data.value2 = JSON.parse(res.data.value2);
        }
        return Promise.resolve(res?.data);
      } catch (error: any) {
        return Promise.resolve({});
      }
    },
    // 查询绑定的三方数字钱包数据
    async getBindThirdWalletData(params: Record<string, any>) {
      const { tenantInfo } = storeToRefs(useTenantStore());
      const { userInfo } = storeToRefs(useUserStore());
      try {
        let data = {
          paramsJson: JSON.stringify({
            tid: tenantInfo.value.tid,
            cust_id: userInfo.value.cust_id,
            ...params,
          }),
        };
        const res: any = await walletServices.getBindThirdWalletData(data);
        return Promise.resolve(res?.data);
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    // 查询是否绑定的三方数字钱包
    async reqBindThirdWallet(params: Record<string, any>) {
      const { tenantInfo } = storeToRefs(useTenantStore());
      const { userInfo } = storeToRefs(useUserStore());
      try {
        let data = {
          paramsJson: JSON.stringify({
            tid: tenantInfo.value.tid,
            cust_id: userInfo.value.cust_id,
            ...params,
          }),
        };
        const res: any = await walletServices.reqBindThirdWallet(data);
        return Promise.resolve(res?.data);
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    // 查询三方数字钱包注册地址
    async getThirdWalletRegisterLink(params: Record<string, any>) {
      const { tenantInfo } = storeToRefs(useTenantStore());
      const { userInfo } = storeToRefs(useUserStore());
      try {
        let data = {
          paramsJson: JSON.stringify({
            tid: tenantInfo.value.tid,
            cust_id: userInfo.value.cust_id,
            ...params,
          }),
        };
        const res: any = await walletServices.getThirdWalletRegisterLink(data);
        return Promise.resolve(res?.data);
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    // 查询三方数字钱包充值地址
    async getThirdWalletDepositLink(params: Record<string, any>) {
      const { tenantInfo } = storeToRefs(useTenantStore());
      const { userInfo } = storeToRefs(useUserStore());
      try {
        let data = {
          paramsJson: JSON.stringify({
            tid: tenantInfo.value.tid,
            cust_id: userInfo.value.cust_id,
            ...params,
          }),
        };
        const res: any = await walletServices.getThirdWalletDepositLink(data);
        return Promise.resolve(res?.data);
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    // 请求三方发送手机验证码
    async reqPhoneVerifyCode(params: Record<string, any>) {
      const { tenantInfo } = storeToRefs(useTenantStore());
      const { userInfo } = storeToRefs(useUserStore());
      try {
        let data = {
          paramsJson: JSON.stringify({
            tid: tenantInfo.value.tid,
            cust_id: userInfo.value.cust_id,
            ...params,
          }),
        };
        const res: any = await walletServices.reqPhoneVerifyCode(data);
        return Promise.resolve(res?.data);
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    // 获取实时汇率
    async getExchangeRate(params: Record<string, any>) {
      const { tenantInfo } = storeToRefs(useTenantStore());
      const { userInfo } = storeToRefs(useUserStore());
      try {
        let data = {
          paramsJson: JSON.stringify({
            tid: tenantInfo.value.tid,
            cust_id: userInfo.value.cust_id,
            ...params,
          }),
        };
        const res: any = await walletServices.getExchangeRate(data);
        return Promise.resolve(res?.data);
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
  },
});
